// extracted by css-extract-rspack-plugin
export default {"cls1":"buttonStyles-cls1_z5L","cls2":"buttonStyles-cls2_9Gt buttonStyles-cls1_z5L"};